// © Microsoft Corporation. All rights reserved.

import { accentFillRest, neutralForegroundHint, neutralForegroundRest, neutralLayerCard } from "@microsoft/fast-components-styles-msft";

import { reset } from "../utils/commonJssConstants";

const avatarSize = "64px";

export const MultiLoginPageStyles = {
    multiLoginPageContainer: {
        ...reset,
        overflow: "hidden",
        "overflow-y": "auto",
        position: "relative",
        display: "flex",
        "flex-direction": "column",
        "align-items": "center",
        "justify-content": "flex-start",
        width: "500px",
        "max-width": "calc(100vw - 40px)",
        padding: "40px 20px",
        background: neutralLayerCard,

        "&:before": {
            content: "' '",
            position: "absolute",
            top: "0",
            height: "8px",
            width: "100%",
            background: accentFillRest
        },

        "& p.cwt-title": {
            margin: "22px 0 28px",
            "font-size": "24px",
            "font-weight": "600",
            color: neutralForegroundRest
        },

        "& .cwt-avatar": {
            height: avatarSize,
            width: avatarSize,
            "min-width": avatarSize
        },

        "& .cwt-fast-button.cwt-image-button": {
            width: "250px",
            height: "auto",
            "justify-content": "stretch",
            "max-width": "96%",
            margin: "5px 0",
            padding: "11px 0",

            "& .cwt-image": {
                margin: "0 25px"
            }
        },

        "& .cwt-privacy-text": {
            margin: "40px 16px 16px",
            "font-size": "13px",
            color: neutralForegroundHint,

            "& .cwt-link": {
                padding: "0 .1em",
                color: accentFillRest
            }
        }
    }
};